import { useCallback, useMemo } from 'react';
import { captureException } from '../utils/sentryUtils';
import { useGetApprovalConfigurationQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
export const useApprovalConfig = (approvalType, approvalAction) => {
  const {
    data: queryData,
    loading: queryLoading,
    error: queryError,
    refetch: queryRefetch
  } = useGetApprovalConfigurationQuery({
    variables: {
      approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
      approvalAction
    },
    // fetchPolicy 'network-only' ensures fresh data. If removing this need to test extensively
    fetchPolicy: 'network-only',
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovalConfig',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const config = useMemo(() => {
    if (!queryData) {
      // If we cannot get a response from config endpoint, we will set approvals to enabled:false
      const enabled = queryError ? false : null;
      return {
        approvalAction,
        approvalType,
        enabled,
        portalId: null
      };
    }
    const {
      approvalConfiguration
    } = queryData;
    return {
      // We already have the approvalAction and approvalType so don't need to use the response values,
      // this also avoids the TS error from unhandled enum case. In future I want to remove all FE types tho
      approvalAction,
      approvalType,
      enabled: approvalConfiguration.enabled,
      portalId: approvalConfiguration.portalId,
      skipApprovalOption: approvalConfiguration.skipApprovalOption,
      usersIdsListThatCanSkipApproval: approvalConfiguration.usersIdsListThatCanSkipApproval,
      approvalTemplate: approvalConfiguration.approvalTemplate
    };
  }, [queryData, queryError, approvalAction, approvalType]);
  const fetchConfig = useCallback(() => {
    void queryRefetch();
  }, [queryRefetch]);
  return useMemo(() => ({
    config,
    fetchConfig,
    hasFetchError: Boolean(queryError),
    isLoading: queryLoading
  }), [queryError, queryLoading, config, fetchConfig]);
};